export const chatIntegrations = [
  {
    name: 'Facebook',
    icon: 'LOGO_FACEBOOK',
  },
  {
    name: 'LINE',
    icon: 'LOGO_LINE',
  },
  {
    name: 'Shopee',
    icon: 'LOGO_SHOPEE',
  },
  {
    name: 'Lazada',
    icon: 'LOGO_LAZADA',
  },
  {
    name: 'TikTok Shop',
    icon: 'LOGO_TIKTOK',
  },
]

export enum EAccountConnectionType {
  Facebook = 'facebook',
  Line = 'line',
  Shopee = 'shopee',
  Lazada = 'lazada',
  TikTokShop = 'tiktok',
}

export const accountIconMap = {
  [EAccountConnectionType.Facebook]: 'LOGO_FACEBOOK',
  [EAccountConnectionType.Line]: 'LOGO_LINE',
  [EAccountConnectionType.Shopee]: 'LOGO_SHOPEE',
  [EAccountConnectionType.Lazada]: 'LOGO_LAZADA',
  [EAccountConnectionType.TikTokShop]: 'LOGO_TIKTOK',
}

export enum EAccountConnectionStatus {
  Connected = 'connected',
  Disconnected = 'disconnected',
}

export const accountConnectionsStatusMap = {
  [EAccountConnectionStatus.Connected]: 'เชื่อมต่อแล้ว',
  [EAccountConnectionStatus.Disconnected]: 'ยังไม่เชื่อมต่อ',
}

export const accountConnectionsPlatformMap = {
  [EAccountConnectionType.Facebook]: 'Facebook',
  [EAccountConnectionType.Line]: 'LINE OA',
  [EAccountConnectionType.Shopee]: 'Shopee',
  [EAccountConnectionType.Lazada]: 'Lazada',
  [EAccountConnectionType.TikTokShop]: 'TikTok Shop',
}

export const accountConnections = [
  {
    name: accountConnectionsPlatformMap[EAccountConnectionType.TikTokShop],
    description: 'เชื่อมต่อหลายบัญชี',
    buttonText: 'เชื่อมต่อ',
    icon: 'LOGO_TIKTOK',
    isNew: false,
    platform: EAccountConnectionType.TikTokShop,
    status: 'active',
  },
  {
    name: accountConnectionsPlatformMap[EAccountConnectionType.Facebook],
    description: 'เชื่อมต่อหลายบัญชี',
    buttonText: 'เชื่อมต่อ',
    icon: 'LOGO_FACEBOOK',
    platform: EAccountConnectionType.Facebook,
    status: 'active',
  },
  {
    name: accountConnectionsPlatformMap[EAccountConnectionType.Line],
    description: 'เชื่อมต่อหลายบัญชี',
    buttonText: 'เชื่อมต่อ',
    icon: 'LOGO_LINE',
    platform: EAccountConnectionType.Line,
    status: 'disabled',
  },
  {
    name: accountConnectionsPlatformMap[EAccountConnectionType.Shopee],
    description: 'เชื่อมต่อหลายบัญชี',
    buttonText: 'เชื่อมต่อ',
    icon: 'LOGO_SHOPEE',
    platform: EAccountConnectionType.Shopee,
    status: 'disabled',
  },
  {
    name: accountConnectionsPlatformMap[EAccountConnectionType.Lazada],
    description: 'เชื่อมต่อหลายบัญชี',
    buttonText: 'เชื่อมต่อ',
    icon: 'LOGO_LAZADA',
    platform: EAccountConnectionType.Lazada,
    status: 'disabled',
  },
]

export const tags = [
  { name: 'ลูกค้าออนไลน์', color: '#219653' },
  { name: 'ลูกค้าหน้าร้าน', color: '#219653' },
  { name: 'ไม่สนใจ', color: '#999999' },
  { name: 'พรีออเดอร์', color: '#2D9CDB' },
  { name: 'ลูกค้าใหม่', color: '#219653' },
  { name: 'ลูกค้าชั้นเยี่ยม', color: '#F2994A' },
  { name: 'สำคัญ', color: '#F2994A' },
  { name: 'รายงานปัญหา', color: '#EB5757' },
  { name: 'VIP', color: '#EB5757' },
]

export enum EColorTag {
  RED = '#EB5757',
  YELLOW = '#F2994A',
  GREEN = '#219653',
  BLUE = '#2D9CDB',
  GREY = '#999999',
}

export const menuItemsTagsOptions = [
  { value: EColorTag.RED, label: 'แดง' },
  { value: EColorTag.YELLOW, label: 'เหลือง' },
  { value: EColorTag.GREEN, label: 'เขียว' },
  { value: EColorTag.BLUE, label: 'ฟ้า' },
  { value: EColorTag.GREY, label: 'เทา' },
]

export const colorsTagMap = {
  [EColorTag.RED]: 'แดง',
  [EColorTag.YELLOW]: 'เหลือง',
  [EColorTag.GREEN]: 'เขียว',
  [EColorTag.BLUE]: 'ฟ้า',
  [EColorTag.GREY]: 'เทา',
}

export interface IAccountConnectionsList {
  platform: EAccountConnectionType
  accounts: IAccount[]
}

export interface IAccount {
  image: string
  name: string
  status: EAccountConnectionStatus
  category?: string
  id: string
  assigns?: string[]
  objectId?: string
}
